import { TIMELINE } from "../../../mocks/gossip";
import { CategoryChip, SectionHead } from "./Shared";

export default function TimelineSection() {
  return (
    <section
      id="breaking"
      className="w-full bg-background-100/70 py-10 md:py-14"
      aria-label="刚刚爆出的新瓜时间线"
    >
      <div className="container-x">
        <div className="grid grid-cols-1 gap-8 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <div className="lg:sticky lg:top-32">
              <SectionHead
                eyebrow="BREAKING NOW"
                anchor="breaking"
                title="刚刚爆 · 实时时间线"
                desc="按时间倒序追踪今天每个小时都有哪些新瓜落地。红点代表仍在发酵的事件，点击分类标签即可了解焦点方向。"
              />
              <div className="hidden flex-wrap items-center gap-2 lg:flex">
                <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-500 px-3 py-1 text-xs font-semibold text-background-50">
                  <i className="ri-radio-button-line animate-pulse" />
                  今日已更新 6 条
                </span>
                <span className="inline-flex items-center gap-1 rounded-full bg-accent-100 px-3 py-1 text-xs font-semibold text-accent-800">
                  事件仍在跟进中
                </span>
              </div>
            </div>
          </div>

          <div className="lg:col-span-8">
            <ol className="relative space-y-4 border-l-2 border-primary-200 pl-5 md:pl-6">
              {TIMELINE.map((ev, i) => (
                <li key={i} className="relative">
                  <span
                    className={`absolute -left-[27px] top-2 flex h-4 w-4 items-center justify-center rounded-full border-4 md:-left-[30px] ${
                      i < 2 ? "border-primary-500 bg-background-50" : "border-accent-300 bg-background-50"
                    }`}
                  >
                    <span className={`h-1.5 w-1.5 rounded-full ${i < 2 ? "bg-primary-500" : "bg-accent-400"}`} />
                  </span>
                  <article className="group rounded-xl border border-background-200 bg-background-50 p-4 transition-colors hover:border-primary-200 md:p-5">
                    <div className="flex flex-wrap items-center gap-2">
                      <span className="inline-flex items-center gap-1 font-label text-sm font-bold text-primary-600">
                        <i className="ri-time-line text-[13px]" />
                        {ev.time}
                      </span>
                      <CategoryChip label={ev.category} toneKey={ev.categoryKey} />
                      <span className="ml-auto text-[11px] text-foreground-400">第 {String(i + 1).padStart(2, "0")} 条</span>
                    </div>
                    <h3 className="mt-2 font-heading text-base font-bold leading-snug text-foreground-950 md:text-lg">
                      {ev.text}
                    </h3>
                    <p className="mt-1.5 text-sm leading-6 text-foreground-600">{ev.detail}</p>
                  </article>
                </li>
              ))}
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
}